<template>
  <div>
    <van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" @load="loadMore">
      <van-cell v-for="course in courseList" :key="course.itemId" @click="viewCourse(course)">
        <template slot="title">
          <van-row>
            <van-col span="6" class="course-image">
              <img :src="getImageUrl(course.itemImageUri)">
            </van-col>
            <van-col span="17" offset="1" class="course-info">
              <van-row>
                <van-col span="20" class="course-name">{{ course.itemName }}</van-col>
                <van-col span="4" class="text-right">
                  <span v-if="isCutoff(course)" class="cutoff">已截止</span>
                </van-col>
              </van-row>
              <div class="course-point text-right">积分：{{ course.basePoint }}</div>
              <van-row class="course-detail">
                <van-col span="20">
                  {{ parseTime(course.startTime, '{y}/{m}/{d}') }}-{{ parseTime(course.endTime, '{y}/{m}/{d}') }}
                </van-col>
                <van-col span="4" class="text-right">
                  {{ course.courseLocation }}
                </van-col>
              </van-row>
            </van-col>
          </van-row>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import itemApi from '@/api/item'
import { commonUtils } from '@/utils/common'
import { userUtils } from '@/utils/auth'
export default {
  name: 'CourseOfflineList',
  props: {
    categoryCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      finished: false,
      courseList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      clientInfo: null
    }
  },
  created () {
    this.clientInfo = userUtils.getClientInfo()
    if (!this.clientInfo) {
      window.location.href = commonUtils.getExtraSite() + '/#/login'
    }
  },
  methods: {
    getImageUrl: commonUtils.getImageUrl,
    parseTime: commonUtils.parseTime,
    load () {
      if (!this.categoryCode) {
        return
      }
      this.courseList = []
      this.page = 1
      this.queryCourseOfflineList()
    },
    loadMore () {
      if (this.finished) {
        this.loading = false
        return
      }
      this.page += 1
      this.queryCourseOfflineList()
    },
    queryCourseOfflineList () {
      if (!this.categoryCode) {
        return
      }
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '读取课程信息'
      })
      const params = {
        page: this.page,
        pageSize: this.pageSize,
        categoryCode: this.categoryCode
      }
      itemApi.queryItemList(params).then(response => {
        this.$toast.clear()
        this.loading = false
        if (response.data.resultCode === '0') {
          this.courseList = this.courseList.concat(response.data.resultData.itemList || [])
          this.total = response.data.resultData.pageInfo.totalCounts
          if (this.total <= this.courseList.length) {
            this.finished = true
          }
        }
      }).catch(() => {
        this.$toast.clear()
        this.loading = false
      })
    },
    isCutoff (course) {
      if (!course) {
        return false
      }
      const cutoffDate = this.parseTime(course.cutoffTime, '{y}-{m}-{d}')
      const curDate = this.parseTime(new Date(), '{y}-{m}-{d}')
      return cutoffDate < curDate
    },
    viewCourse (course) {
      window.location.href = commonUtils.getExtraSite() + '/#/goodsDetail/' + course.itemId
    }
  }
}
</script>

<style lang="less" scoped>
.course-image {
  text-align: center;

  img {
    max-width: 90%;
    max-height: 60px;
  }
}
.course-info {
  line-height: 22px;

  .course-name {
    color: #117281;
  }
  .course-detail {
    font-size: 12px;
  }
  .cutoff {
    color: red;
    font-size: 12px;
  }
}
</style>
